<!--抄表信息配置界面，只有这里配的表才是计费表-->
<template>
	<treeBody>
		<virtualDeviceTree slot="tree" :dataList="[$store.unitStore.getters.getNowUnit]" :autoSelectMethod='autoSelectMethod'
		 :isGroup="isGroup" :groupCheckAble="true"></virtualDeviceTree>
		<div slot="body" style="width: 100%">
			<div style="height: 100%;" class="card-box custom-scrollbar">
				<div class="card-add" style="height: 160px;" title="添加新计量表" @click="addMeter"><img class="img-add" :src="$store.resourcesStore.getters.getResourcesByName('/wedoButton/add.png')"></div>
				<div v-for="item in meterList" class="card-nomal">
					<p class="card-title" :style="$store.resourcesStore.getters.getBackgroudImageStyle('card_title_bg.png')">{{item.deviceName}}</p>
					<div class="card-info">
						<p>计费方式：{{billingMode(item.billingMode)}}</p>
						<p>扣款日：每月{{item.deductionFeeDay}} 日</p>
						<p>余额：{{getBalance(item.id)}} 元</p>
						<p>状态：{{item.state == 0 ? '正常':'欠费'}}</p>
					</div>
					<div class="card-button-box">
						<button class="specialButton" @click="deleteMeter(item)">删除</button>
						<button class="nomalButton" @click="$emit('showDetails',item)">详情</button>
					</div>
				</div>
				<div v-for="item in 6" class="card-empty"></div>
			</div>
		</div>
		<createMeterDialog ref="createMeterBean" @createSuccess="loadMeterList(nowUnitId)"></createMeterDialog>
	</treeBody>
</template>

<script>
	import treeBody from '@/components/module/slotModule/treeBody.vue'
	import virtualDeviceTree from '@/components/module/tree/virtualDeviceTree.vue'
	import createMeterDialog from './createMeterDialog.vue'
	export default {
		components: {
			treeBody,
			virtualDeviceTree,
			createMeterDialog
		},
		props: {},
		data() {
			return {
				meterList: []
			}
		},
		created() {},
		mounted() {
			this.loadMeterList(this.nowUnitId)
		},
		destroyed() {},
		computed: {
			nowUnitId() {
				return this.$store.unitStore.getters.getNowUnit.id
			},
			usePowerMeterTree() {
				//还未配置为计费表的带用电量的仪表
				var tree = this.$store.deviceStore.getters.getReadDeviceTreeWithTypeNos(36, this.nowUnitId)
				var nos = this.meterList.map(item => item.id)
				return filterTreeRecursive([copy(tree)], item => {
					return !(item.entityName == "VirtualDevicePojo" && nos.includes(item.id))
				})[0]
			},
			billingMode() {
				return mode => {
					switch (mode) {
						case 'StepBilling':
							return '阶梯计费'
						case 'PeakAndValleyBilling':
							return '峰平谷计费'
						case 'SingleBilling':
							return '单价计费'
						default:
							return '无效计费' + mode
					}
				}
			},
			getBalance() {
				return deviceNo => {
					var balance = this.$store.moneyStore.getters.getBalance(deviceNo, 'MeterReading')
					if (balance == undefined) {
						return '--'
					}
					return balance.balance / 100

				}
			}
		},
		watch: {
			usePowerMeterTree(nv, ov) {
			},
			nowUnitId(nv, ov) {
				this.loadMeterList(nv)
			}
		},
		methods: {
			loadMeterList(unitId) {
				this.$api.meterReadingApi.getMeterReadingConfigListByUnitId(unitId, respon => {
					this.meterList = respon
				})
			},
			autoSelectMethod(item, index) {
				return item.type == 0
			},
			isGroup(item) {
				return !isempty(item.next)
			},
			addMeter() {
				//添加计费表
				this.$dialogMethod.getMultipleSelectionDialog().setGetIdMethod(item => item.next == undefined ? item.id : 'group' +
					item.id)
				this.$dialogMethod.openSingleItemDialog('请选择采集电表', getValueIfNoNull(this.usePowerMeterTree.next, []),
					undefined,
					respon => {
						var deviceList = respon.filter(item => item.entityName == "VirtualDevicePojo")
						if (isempty(deviceList)) {
							this.$dialogMethod.showMessage('请选择一个设备！')
							return false
						}
						this.$refs.createMeterBean.show(deviceList[0])
					})
			},
			deleteMeter(item) {
				this.$dialogMethod.openAgreeDialog('删除计费表', '确定要将【' + item.deviceName + '】从计费表中移除吗？设备账单依旧会保留。', respon => {
					this.$api.meterReadingApi.removeMeterReadingConfig(item.id, respon => {
						this.loadMeterList(this.nowUnitId)
					})
				})
			}
		}
	}
</script>

<style scoped>
	@import url("../../../components/css/card.css");
	.card-info>p {
		padding: 2px 0;
	}
</style>
